import React from 'react';

import '../styles/PolicyPages.css';

function ShippingPolicy() {
  return (
    <div className="policy-container">
      <h1>Shipping & Delivery Policy</h1>
      <p className="last-updated">Last Updated: December 5, 2025</p>

      <section>
        <h2>1. Shipping Coverage</h2>
        <ul>
          <li>We currently ship within India only</li>
          <li>International shipping is not available at this time</li>
        </ul>
      </section>

      <section>
        <h2>2. Shipping Charges</h2>
        <ul>
          <li><strong>Free Shipping:</strong> Orders above ₹2499</li>
          <li><strong>Standard Shipping:</strong> ₹ 99 for orders below ₹500</li>
          <li>Charges added at checkout based on location and weight</li>
        </ul>
      </section>

      <section>
        <h2>3. Delivery Timeline</h2>
        <table className="shipping-table">
          <thead>
            <tr>
              <th>Location</th>
              <th>Estimated Delivery</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Metro Cities</td>
              <td>3-5 business days</td>
            </tr>
            <tr>
              <td>Other Cities</td>
              <td>5-7 business days</td>
            </tr>
            <tr>
              <td>Remote Areas</td>
              <td>7-10 business days</td>
            </tr>
          </tbody>
        </table>
        <ul>
          <li><em>Note: Delivery times are estimates and may vary due to courier delays, weather conditions, or other unforeseen circumstances</em></li>
        </ul>
      </section>

      <section>
        <h2>4. Order Processing</h2>
        <ul>
          <li>Orders are processed within 1-2 business days</li>
          <li>Orders placed on weekends/holidays are processed the next business day</li>
          <li>You will receive a tracking number via email once shipped</li>
        </ul>
      </section>

      <section>
        <h2>5. Order Tracking</h2>
        <p>Track your order by:</p>
        <ul>
          <li>Going to Account &gt; Orders</li>
          <li>Clicking on "Track Order"</li>
          <li>Using the tracking number with the courier partner</li>
        </ul>
      </section>

      <section>
        <h2>6. Delivery Attempts</h2>
        <ul>
          <li>Our courier partners will make 3 delivery attempts</li>
          <li>If delivery fails after 3 attempts, the package will be returned to us and you will be notified</li>
          <li>Please ensure someone is available to receive the package and provide correct contact information</li>
        </ul>
      </section>

      <section>
        <h2>7. Shipping Partners</h2>
        <p>We work with reliable courier partners including:</p>
        <ul>
          <li>Shiprocket</li>
          <li>Delhivery</li>
          <li>Blue Dart</li>
          <li>DTDC</li>
        </ul>
      </section>

      <section>
        <h2>8. Damaged Packages</h2>
        <p>
          If you receive a damaged package, please:
        </p>
        <ol>
          <li>Take photos of the package and product</li>
          <li>Contact us immediately at support@kalingastore.shop</li>
          <li>Do not discard the packaging</li>
          <li>We will arrange a replacement or refund</li>
        </ol>
      </section>

      <section>
        <h2>9. Address Changes</h2>
        <ul>
          <li>Address changes are only possible before the order is shipped</li>
          <li>Contact us immediately if you need to update your delivery address</li>
        </ul>
      </section>

      <section>
        <h2>10. Contact Us</h2>
        <ul>
          <li><strong>Email:</strong> support@kalingastore.shop</li>
          <li><strong>Address:</strong> 12A, Old Vijay Nagar, Ghaziabad, Uttar Pradesh - 201001</li>
          <li><strong>Response time:</strong> Within 24-48 hours</li>
        </ul>
      </section>
    </div>
  );
}

export default ShippingPolicy;
